<script setup>
import Facebook from "@i/facebook.svg?component";
import IdealIcon from "@i/ideal.svg?component";
import Instagram from "@i/instagram.svg?component";
import LinkedIn from "@i/linkedin.svg?component";
import LogoF from "@i/logo-f.svg?component";
import Tiktok from "@i/tiktok.svg?component";
import Youtube from "@i/youtube.svg?component";
import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const companyDetails = computed(() => usePage().props.company_details);

const links = computed(() => {
  return [
    {
      name: "Facebook",
      icon: Facebook,
      link: companyDetails.value.facebook,
    },
    {
      name: "TikTok",
      icon: Tiktok,
      link: companyDetails.value.tiktok,
    },
    {
      name: "Instagram",
      icon: Instagram,
      link: companyDetails.value.instagram,
    },
    {
      name: "Youtube",
      icon: Youtube,
      link: companyDetails.value.youtube,
    },
    {
      name: "LinkedIn",
      icon: LinkedIn,
      link: companyDetails.value.linkedin,
    },
  ].filter((link) => link.link);
});
</script>

<template>
    <div class="mt-2">
        <div class="flex items-center justify-between gap-4">
            <div class="flex flex-row gap-2 lg:gap-4">
                <LogoF class="size-8 fill-white" />
                <div />
                <a
                    v-for="link in links"
                    :key="link.name"
                    :href="link.link"
                    target="_blank"
                >
                    <component
                        :is="link.icon"
                        class="size-8 fill-white"
                    />
                </a>
            </div>

            <IdealIcon class="md:hidden" />
        </div>
    </div>
</template>
